<template>
    <v-container>
        <v-toolbar rounded="" color="secondary" dense class="mb-3" elevation="1">
            <v-breadcrumbs class="ms-n6" :items="[{text: 'Purchasing & Ordering'}, {text: 'Accounts Payable'} ,{text: 'Payment',}]" large/>
        </v-toolbar>
        <v-row>
            <v-col cols="6">
                <v-sheet elevation="1">
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Create Payment Mode Account
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn icon @click="handleDiscard">
                                <v-icon>mdi-cancel</v-icon>
                            </v-btn>
                            <v-btn
                                depressed
                                color="primary"
                                @click="handleSave"
                                >
                                <v-icon left>mdi-content-save</v-icon>
                                save
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <div class="pa-4">
                        <PurchasePaymentAccountForm v-model="data" ref="form"/>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-bind="alert" v-model="alert.value"/>
        <LoadingOverlay :value="loading"/>
    </v-container>
</template>

<script>
import PurchasePaymentAccountForm from './../../components/purchase/PurchasePaymentAccountForm.vue';
import PAlert from './../../components/common/PAlert';
import LoadingOverlay from './../../components/common/LoadingOverlay.vue'
import { mapActions } from 'vuex';
import { v4 as uuid } from 'uuid';

export default {
    name: "PurchasePaymentModeAccountCreateView",
    components: {
        PurchasePaymentAccountForm,
        PAlert,
        LoadingOverlay
    },
    data() {
        return {
            data: null,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
            loading: false,
            idempotentKey: null
        }
    },
    methods: {
        ...mapActions({
            create: "purchase/paymentMode/createAccount",
            snackbar: "ui/snackbar/show"
        }),
        handleSave() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to save?", callback: this.save};
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.create({...this.data, idempotentKey: this.idempotentKey}).then(() => {
                this.snackbar({color: "success", text: "Payment Mode Account Created"});
                this.$router.push({ name: "PurchasePaymentModeDisplay", params: { id: this.data.payment_mode } })
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({text: message, color: "error"})
            }).finally(() => {
                this.loading = false
            })
        },
        handleDiscard() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to discard?", callback: this.discard};
        },
        discard() {
            this.$router.push({ name: "PurchasePaymentModeDisplay", params: { id: this.id } })
        }
    },
    
    created() {
        this.data = {}
        this.data.payment_mode = this.$route.params.id;
        this.idempotentKey = uuid();
    },
}
</script>

<style>

</style>